import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { cn } from "@/core/utils";
import Text from "../Text/Text";
type DividerTone = "default" | "muted";
type DividerAlign = "left" | "center" | "right";
export type DividerProps = React.HTMLAttributes<HTMLDivElement> & {
  label?: string;
  tone?: DividerTone;
  align?: DividerAlign;
};
const alignClasses: Record<DividerAlign, string> = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end"
};
const labelPadding: Record<DividerAlign, string> = {
  left: "pl-2",
  center: "",
  right: "pr-2"
};
export function Divider(t0) {
  const $ = _c(20);
  let className;
  let label;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      label,
      tone: t1,
      align: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = label;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    className = $[1];
    label = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const tone = t1 === undefined ? "default" : t1;
  const align = t2 === undefined ? "center" : t2;
  let t3;
  if ($[6] !== className) {
    t3 = cn("relative", className);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = tone === "muted" ? "bg-border/40" : "bg-border";
  let t5;
  if ($[8] !== t4) {
    t5 = cn("h-px w-full", t4);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== align || $[13] !== label) {
    t7 = label ? <div className={cn("absolute inset-0 flex items-center", alignClasses[align])}><span className={cn("bg-background px-2", labelPadding[align])}><Text component="span" text={label} variant="caption" /></span></div> : null;
    $[12] = align;
    $[13] = label;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props || $[16] !== t3 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t3} {...props}>{t6}{t7}</div>;
    $[15] = props;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}